import { ReactComponent as BulbIcon } from "assets/BulbIcon.svg";
import { useAppDispatch } from "redux/hooks";
import "./BubbleToggle.scss";
import { setDrawerVisible } from "./PlanAssignment.slice";

const BubbleToggle = () => {
  const dispatch = useAppDispatch();
  return (
    <div onClick={() => dispatch(setDrawerVisible(true))} className="bubble-toggle-component">
      <BulbIcon />
    </div>
  );
};

export default BubbleToggle;
